export default __webpack_public_path__ + "static/media/Jalsa2.0f9d6c46.mp3";